import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Mail, X, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

const FAB = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-4">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="flex flex-col items-end space-y-3"
            initial={{ opacity: 0, scale: 0.5, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: 20 }}
            transition={{ duration: 0.3, ease: "backOut" }}
          >
            {/* Email Button */}
            <motion.a
              href="mailto:mcubesevents@gmail.com"
              className="flex items-center p-3 rounded-full shadow-lg bg-gray-700 text-white hover:bg-gray-600 transition-colors duration-200"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.2, delay: 0.1 }}
              aria-label="Send us an email"
            >
              <Mail className="w-6 h-6" />
            </motion.a>

            {/* Call Button */}
            <motion.a
              href="tel:+639171700869"
              className="flex items-center p-3 rounded-full shadow-lg bg-gray-700 text-white hover:bg-gray-600 transition-colors duration-200"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.2, delay: 0.2 }}
               aria-label="Call us"
           >
              <Phone className="w-6 h-6" />
            </motion.a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main FAB Button */}
      <motion.button
        onClick={toggleOpen}
        className="w-14 h-14 rounded-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white shadow-lg flex items-center justify-center focus:outline-none"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
         aria-label={isOpen ? "Close contact options" : "Open contact options"}
      >
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          {isOpen ? <X className="w-6 h-6" /> : <MessageSquare className="w-6 h-6" />}
        </motion.div>
      </motion.button>
    </div>
  );
};

export default FAB; 